import { ProctoringOptionCategory } from "../proctoring-options/option-text/ProctoringOptionText";
import ProctoringOptions, { ProctoringOptionsProps } from "../proctoring-options/proctoringOptionsGrid";
import styles from "./index.module.css";
import { CoreLoadingPage } from "../../core/progress-indicators/Spinner";
import { ProctoringDataType } from "../hooks/state/useSettingsState";
import { EditQuizPageProps } from "../editQuiz";
import { StepWrapper } from "./CommonStepComponents";

export type ConfigurationStepProps = {
	loading?: boolean;
	currentCategory: ProctoringOptionCategory;
	data: ProctoringDataType;
	proctoringAssessmentConfiguration: NonNullable<EditQuizPageProps["proctoringAssessmentConfiguration"]>;
} & Pick<
	ProctoringOptionsProps,
	| "data"
	| "enabledProctoringOptions"
	| "enforcedProfilesOnly"
	| "optionRelatedInstituteSettings"
	| "proctoringOption"
	| "setProctoringOption"
	| "verityInstituteSettings"
	| "onFocusProctoringOption"
	| "proctoringOptionToFocus"
	| "quizType"
>;

export default function ConfigurationStep({
	loading,
	data,
	currentCategory,
	proctoringAssessmentConfiguration,
	enabledProctoringOptions,
	enforcedProfilesOnly,
	proctoringOption,
	setProctoringOption,
	verityInstituteSettings,
	optionRelatedInstituteSettings,
	onFocusProctoringOption,
	proctoringOptionToFocus,
	quizType,
}: ConfigurationStepProps) {
	const hasPassword = Boolean(
		proctoringAssessmentConfiguration.thirdPartyAssessmentOption?.password &&
		proctoringAssessmentConfiguration.thirdPartyAssessmentOption?.password !== "",
	);

	if (loading) return <CoreLoadingPage size={100} />;

	return (
		<StepWrapper>
			<div className={styles.configurationPage}>
				<ProctoringOptions
					data={data}
					currentCategory={currentCategory}
					hasPassword={hasPassword}
					enabledProctoringOptions={enabledProctoringOptions}
					enforcedProfilesOnly={enforcedProfilesOnly}
					proctoringOption={proctoringOption}
					setProctoringOption={setProctoringOption}
					verityInstituteSettings={verityInstituteSettings}
					optionRelatedInstituteSettings={optionRelatedInstituteSettings}
					onFocusProctoringOption={onFocusProctoringOption}
					proctoringOptionToFocus={proctoringOptionToFocus}
					quizType={quizType}
				/>
			</div>
		</StepWrapper>
	);
}
